jQuery(document).ready(function ($) {
  $(".new-categories-list .list").slick({
    centerMode: false,
    arrows: true,
    dots: false,
    infinite: true,
    slidesToShow: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          arrows: false,
          slidesToShow: 3.3,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 5,
        },
      },
      {
        breakpoint: 99999,
        settings: {
          slidesToShow: 7,
        },
      },
    ],
  });

  var listSize = $(".categories-list .slick-dots").width();

  $(".categories-list .slick-prev").css(
    "margin-left",
    -(listSize / 2) - 41 + "px"
  );

  $(".categories-list .slick-next").css(
    "margin-left",
    listSize / 2 + 20 + "px"
  );

  $(".js-btn-load-more").on("click", function () {
    $(".categories-list ul").addClass("show-all");
    $(".js-btn-load-more").slideUp();
  });
  let itensMenu = document.querySelectorAll(
    ".new-categories-list .slick-slide"
  );

  if (itensMenu.length > 0) {
    itensMenu.forEach((itemMenu) => {
      let titleItem = itemMenu.querySelector(".title h4");
      let titleText = titleItem.innerText;
      let titleContain = titleText.includes("LANÇAMENTOS");
      if (titleContain) {
        itemMenu.remove();
      }
    });
  }
});
